

import React, { useEffect, useState } from "react";
import Navbar from "../../../Component/Home/Navbar";
import img7 from "../../../Assets/home/img7.png";
import logo from "../../../Assets/footer/logo.svg";
import Fb from "../../../Assets/footer/Fb.svg";
import Insta from "../../../Assets/footer/Insta.svg";
import LinkedIn from "../../../Assets/footer/LinkedIn.svg";
import Youtube from "../../../Assets/footer/Youtube.svg";
import BlogImg1 from "../../../Assets/Blogs/BlogImg1.jpg";
import Blog3 from "../../../Assets/home/Blog3.jpg";
import Blog2 from "../../../Assets/Blogs/Blog2.jpg";
import { useNavigate } from "react-router-dom";

 const blogCards = [
  { id:1,
    title:
      " We are delighted to announce that Mr. Bhavneesh Malik, the founder and managing director of BCV ClaimPro Assist Pvt. Ltd., has been honored with the prestigious Leading Innovator in Logistics Solutions award by the ET Business Awards, an initiative by The Times of India Group. ",
    image: BlogImg1,
  },

  // { id:2,
  //   title: "This prestigious award is a testament to our team's relentless pursuit of innovation, customer-centric solutions, and tech-led transformation in the Vehicle support ecosystem.",
  //   image: Blog2,
  // },

  { id:2,
    title: "Proud Moment for ClaimPro Assist Pvt. Ltd. We are delighted to share that our Chief Technology Officer, Mr. Mohan Shah, has been honoured with the prestigious “Eminent CIOs of India 2025-2026” award by VAR India.The award was presented at the VAR India Infotech Forum 2025, held on 4th July 2025 at Hotel Hyatt Regency, New Delhi.",
    image: Blog3,
  },
  // {
  //   title:
  //     "How to deal with insurance adjusters? What about insurance kjdjdoisjd jsdijsdiojs idjsiofei jdsijfi jddjj",
  //   image: img7,
  // },
];


export default function BlogsPage() {
  const [modalData, setModalData] = useState(null);
   const navigate = useNavigate();

    useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    scrollToTop();
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);


  return (
    <div className="font-satoshi min-h-screen bg-white">
      <Navbar />

      {/* <header className="bg-[#21A6E9] text-white p-2 shadow-md sticky top-[80px] z-40 font-satoshi">
        <h1 className="text-2xl font-bold text-center">News & Insights</h1>
      </header> */}
      <div className="md:px-[5%] px-[5%]  font-satoshi">
      <div className="pb-2 pt-[2rem] px-0">
                
                <button
                  
                  className="bg-[#ffffff] hover:bg-[#21A6E9] items-center border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[18px] leading-[26px] ease-in transition-all"
                >
                  News & Insights
                </button>
              </div>

      <main className="max-w-6xl mx-auto  text-center">
        <h6 className="max-w-full w-full font-satoshi font-[500] text-[#1B2E3F] text-[6vw] sm:text-[5vw] md:text-[2vw] leading-snug pb-[20px]">
                 Expert Tips, News & Insights
                </h6>
        {/* Blog Cards Section */}
       
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 py-10">
       {blogCards.map((card, index) => (
                  
                    <div className="bg-white rounded-[16px] shadow-md p-3 text-center mx-auto max-w-[350px] h-[26rem] mb-[2rem] flex flex-col">
                      <img
                        src={card.image}
                        className="rounded-[16px] h-[200px] w-full object-cover bg-white mb-2"
                        alt={card.title}
                      />

                      <div className="h-[120px] overflow-hidden mb-3">
                        <h6 className="font-satoshi font-[500] text-[10px] md:text-[14px] text-[#000000] leading-relaxed line-clamp-5 text-left">
                          {card.title}
                        </h6>
                      </div>

                      <div className="flex justify-center">
                        <button  
                          onClick={() => {
                            navigate("/read-blogs", {
                              state: { blogId: card.id  },
                            });
                          }}
                          className="bg-[#21A6E9] text-white text-[16px] py-2 px-4 rounded-full font-satoshi font-[400] hover:bg-[#1789c4] transition w-auto"
                        >
                          Read More
                        </button>
                      </div>
                    </div>
                  
                ))}
        </div>
      </main></div>

      {/* Footer */}
      <div className="bg-[#E5F6FF] py-2 px-4 md:px-12 flex flex-col md:flex-row justify-between items-center md:items-start font-satoshi">
             {/* Left: Logo and Name */}
             <div className="flex items-center gap-2 mt-2 mb-1 md:mb-0 flex-nowrap">
               <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/logo-footer-compressed.png' alt="ClaimPro Assist Logo" className="h-12" />
               <p className=" font-satoshi text-[18px] leading-[32px] text-[#0A0119] mb-0 whitespace-nowrap">
                 © 2025 BCV ClaimPro Assist Private Limited.
               </p>
             </div>
     
             {/* Right: Social Links */}
             <div className="text-right font-satoshi">
               <p className="text-[18px] mr-2 mb-1">Follow us on</p>
               <div className="flex gap-2 items-end">
                 <a
                   href="https://www.facebook.com/p/BVC-ClaimPro-Assist-61559865797607/"
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Fb.svg' alt="Facebook" className="h-6 w-6" />
                 </a>
                 <a
                   href="https://www.instagram.com/bvc_claimpro_assist_official/"
                   target="_blank"
                   rel="noopener noreferrer"
                 > 
                   <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Insta.svg' alt="Instagram" className="h-6 w-6" />
                 </a>
                 <a
                   href="https://in.linkedin.com/company/bvc-claim-pro-assist"
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/LinkedIn.svg' alt="LinkedIn" className="h-6 w-6" />
                 </a>
                 <a
                   href="https://www.youtube.com/watch?v=qmUlSNG5xKg"
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Youtube.svg' alt="YouTube" className="h-6 w-6" />
                 </a>
               </div>
             </div>
           </div>
    </div>
  );
}
